const app = {
	state: {
		width: 0
	},
	mutations: {
		'app:update:width' (state, width) {
			state.width = width;
		},

        'app:create:scroll' (state, el) {
            el.Scroll = new el.$BScroll(el.$refs.scroll, {
                click: true
            })
        }
	},
	actions: {
		'app:update:width' ({commit}, width) {
			commit('app:update:width', width);
		},

        'app:create:scroll' ({commit}, el) {
            commit('app:create:scroll', el);
        }
	},
	getters: {
		'app:width': state => {
			return state.width;
		}
	}
};

export default app;


// WEBPACK FOOTER //
// ./src/store/modules/app.js